<template>
    <div class="footer">
        <div class="footer-li" v-for="(itemK, indexK) in footerList" :key="indexK">
            <div class="footer-title" v-if="itemK.title">{{ itemK.title }}</div>
            <img class="footer-img" v-else :src="itemK.img" alt="">
            <div v-if="itemK.content" :class="['footer-content', {'footer-actived': itemK.contentUrl}]" @click="handleClick(itemK)">{{ itemK.content }}</div>
            <div v-else class="footer-content  footer-content-list">
            <div class="footer-content-li" v-for="K in itemK.list" :key="K"> {{  K }} </div>
            </div>
            <div v-if="itemK.iconList" class="footer-icon">
            <img v-for="icon in itemK.iconList" :key="icon" :src="icon" alt="">
            </div>
        </div>
    </div>
</template>

  <script>
  export default {
    data() {
      return {
        footerList: [
          {
            title: '关于我们',
            content: '主页',
            contentUrl: '/home'
          },
          {
            title: '联系我们',
            list: [
              '咨询电话（内地）：+86 18911057086',
              '咨询电话（香港）：+852 67559270',
              '微信：hongkongyc852',
              'whatsapp：67559270',
              '联系地址：',
              '香港上环德辅道西32-36号 利丰商业大厦 2楼 全层',
              '香港上环永乐街118号昌生商业大厦6楼 全层'
            ]
            // content: '关注',
            // iconList: [
            //   require('@/assets/weibo.png'),
            //   require('@/assets/weixin.png'),
            // ]
          },
          {
            title: '我们的服务',
            list: ['香港身份', '新加坡身份','香港升学','新加坡升学','财富管理','境外保险','公司注册','银行开户']
          },
          {
            title: '',
            img: require('@/assets/new_logo.png'),
            list: ['博润国际（Brillink Global）成立于2014年，植根于香港，并在新加坡、北京、成都设有分支机构，长期专注于为高净值人士与企业家提供海外身份办理、业务出海、子女教育升学及境外资产配置等全球化解决方案。']
            // content: '博润国际于2014年创立，北京、香港两地办公，支持国家政府推动两岸人才流动，两岸关系和谐发展，两岸文化融合。创始人为香港居民，毕业于华侨最高学府，长期定居香港，紧贴香港政策，精准服务新港人'
          },
        ]
      }
    },
    methods: {
      handleClick(item) {
        if(item.contentUrl) {
          this.$router.push({path: item.contentUrl})
          window.scrollTo({top: 0})
        }
      }
    }
  }
  
  </script>
  
  <style scoped lang="scss">
  .footer {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 320Px;
    padding-top: 60Px 375Px;
    // margin-top: 88Px;
    background: #F0F0F0;
  }
  .footer-li:first-child {
    width: 199Px;
  }
  .footer-li:nth-child(2) {
    width: 350Px;
  }
  .footer-li:nth-child(3) {
    width: 302Px;
    .footer-content-list {
      display: flex;
      flex-wrap: wrap;
    }
    .footer-content-li {
      padding-right: 20Px;
      flex-shrink: 0;
      &:nth-child(1) {
        padding-right: 50px
      }
      &:nth-child(3) {
        padding-right: 50px
      }
      &:nth-child(5) {
        padding-right: 50px
      }
      &:nth-child(7) {
        padding-right: 50px
      }
      &:nth-child(2) {
        padding-right: 160px
      }
      &:nth-child(4) {
        padding-right: 160px
      }
      &:nth-child(6) {
        padding-right: 160px
      }
    }
  }
  .footer-actived {
    cursor: pointer;
  }
  .footer-li {
    // width: 1170Px;
    margin-top: 80px;
  }
  .footer-li:last-child {
    width: 416Px;
    .footer-content {
      // margin-top: -82Px;
    }
  }
  .footer-title {
    font-size: 22Px;
    color: #333333;
    line-height: 32Px;
    margin-bottom: 18Px;
  }
  .footer-img {
    width: 124Px;
    margin: -20Px -6Px 12Px 0;
  }
  .footer-content {
    font-size: 14Px;
    font-weight: 400;
    font-family: MicrosoftYaHei;
    color: #B3B3B3;
    line-height: 24Px;
  }
  .footer-content-list {
    // width: 180Px;
  }
  .footer-content-li {
    padding-right: 30Px;
    font-weight: 400;
  }
  .footer-icon {
    display: flex;
    align-items: center;
    margin-top: 7Px;
  }
  .footer-icon img {
    height: 14Px;
    padding-right: 18Px;
  }
  @include h5() {
    .footer {
        width: calc(100% - 58px);
        height: auto !important;;
        padding-bottom: 70px!important;
        padding: 0 0 0 58px;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 350px;
        padding-top: 58px;
        margin-top: 38px;
    }
    .footer-content {
        font-size: 20px;
        line-height: 24px;
    }
    .footer-li:first-child {
        min-width: 110px;
        width: 12.3%;
    }
    .footer-li:nth-child(2) {
        min-width: 190px;
        width: 50%;
    }
    .footer-li:nth-child(3) {
        min-width: 180px;
        width: 22.3%;
        .footer-content {
            width: 160px;
        }
        .footer-content-li {
          padding-right: 50px!important;
          flex-shrink: 0;
          &:nth-child(2) {
            padding-right: 40px!important;
          }
        }
    }
    .footer-li:last-child {
        min-width: 640px;
        width: calc(100% - 48px);
        margin-top: 30px;
        .footer-content {
          line-height: 34px;
          margin-top: unset;
        }
    }
    .footer-title {
        font-size: 24px;
        line-height: 31px;
        margin-bottom: 16px;
    }
    .footer-img {
        width: 194px;
        // height: 60px;
        margin: 0 0 12px 0;
    }
    .footer-content-li {
        padding-right: 0px;
        font-size: 20px;
        line-height: 34px;
        // white-space: nowrap;
    }
    .footer-icon img {
      height: 20px;
      padding-right: 20px;
    }
  }
  </style>